module.exports = __webpack_public_path__ + "img/icon_map_36_on_100.072b307a.png";